export enum DealRoomStatus {
  OPEN_FOR_REPRESENTATIVE = 1,
  OPEN_FOR_CUSTOMER = 2,
  CLOSED = 9,
}

export enum DealRoomDigitalFormStatus {
  OPEN = 1,
  CLOSED = 2,
}

export enum DealRoomDigitalFormType {
  PROPOSAL_FOR_JOINT_HOME_INSURANCE = 1010,
  CHARGING_STATION_FOR_ELECTRIC_VEHICLE = 1015,
  PAYMENT_REQUEST_CHECKS = 1020,
  EARTHQUAKE_WAIVER = 1030,
  COMMERCIAL_AREAS_COVERAGE_WAIVER = 1040,
  BUILDING_COMMITTEES_SALES_SURVEY = 1061,
  BUILDING_COMMITTEES_SERVICE_SURVEY = 1062,
  LEAD_SURVEY_FOR_MEMBERS_OF_THE_HOUSING_CULTURE_ASSOCIATION = 1065,
  LEAD_SUB_AGENT = 2021,
  LEAD_CONTACT_DETAILS_FOR_PROPOSALS = 2022,
}

export enum DealRoomClosingReason {
  CONFIRMED = 1,
  EXPIRED = 2,
  CLOSED_MANUALLY = 3,
  FOR_USER_TREATMENT = 4,
  OTHER_FORM_WAS_SIGNED = 5,
  SAFE_RECORD_CREATED = 6,
}

export enum DealRoomSection {
  OPENING = 'opening',
  INSURANCE_COVERAGE_SHARED_BUILDING = 'insurance-coverage-shared-building',
  THIRD_PARTY_INSURANCE = 'third-party-insurance', // sub start
  PERSONAL_CLAIMS_FOR_COMMITTEE_MEMBERS = 'personal-claims-for-committee-members',
  EMPLOYERS_LIABILITY = 'employers-liability',
  SHARED_BUILDING_STRUCTURE = 'shared-building-structure',
  EARTHQUAKE = 'earthquake',
  SHARED_BUILDING_CONTENTS = 'shared-building-contents', // sub end
  /** Parent of the per-comparison menu entries; its own children are the comparisons themselves. */
  COMPARISONS = 'comparisons',
  ELECTRIC_CHARGING_STATION = 'electric-charging-station',
  DOCUMENTS = 'documents',
  LISTEN_TO_OUR_PODCASTS = 'listen-to-our-podcasts',
  SMART_CHOICE = 'smart-choice',
  PODCAST_INSURANCE = 'podcast-insurance',
  PODCAST_LEGAL = 'podcast-legal',
  PODCAST_MANAGEMENT_APP = 'podcast-management-app',
  PODCAST_FIRE_SAFETY = 'podcast-fire-safety',
  PODCAST_MANAGEMENT_COMPANIES = 'podcast-management-companies',
  PODCAST_MAINTENANCE = 'podcast-maintenance',
  PODCAST_NEW_BUILDINGS_FORM_4 = 'podcast-new-buildings-form-4',
  ATTACHMENTS = 'attachments',
  DECIDED_TO_PURCHASE_THE_INSURANCE = 'decided-to-purchase-the-insurance',
}

export enum DealRoomType {
  NEW_OFFER = 1,
  RENEWAL = 2,
  CLAIM = 3,
  MANAGEMENT_COMPANY = 4,
  COLLECTION = 5,
  SERVICE = 6,
}

export enum DealRoomDocumentType {
  PROPOSAL_FORM = 1,
  NEEDS_ASSESSMENT_FORM = 2,
  MEDICAL_QUESTIONNAIRE = 3,
  CANCELLATION_LETTER = 4,
  ID_COPY = 5,
  PROPOSAL_EMAIL_SENT_TO_CUSTOMER = 6,
  MEDICAL_DOCUMENTS = 7,
  APPROVAL_FOR_ISSUANCE = 8,
  COPY_OF_PREVIOUS_POLICY = 9,
  PROOF_OF_PAYMENT_FOR_PREVIOUS_POLICY = 10,
  CONTROL_FORM = 12,
  MISSING_DOCUMENTS_FOR_ISSUANCE = 13,
  UNDERWRITING_DEFICIENCIES = 14,
  UNDERWRITING_CONDITIONS = 15,
  POWER_OF_ATTORNEY_FOR_THE_INSURANCE_MOUNTAIN_GOV_DATABASE = 17,
  POA_TO_RECEIVE_INFO_FROM_INSURANCE_COMPANIES = 18,
  POA_FOR_PENSION_CLEARINGHOUSE = 19,
  POA_FOR_POLICY_CANCELLATION = 20,
  MIX_COMPOSITION = 21,
  INITIAL_EMAIL_FROM_ADVISOR = 22,
  COVERAGE_DECREASE_LETTER_TO_CUSTOMER = 23,
  COVERAGE_INCREASE_LETTER_TO_CUSTOMER = 24,
  PAYMENT_METHOD_UPDATE_FORM_NOT_FOR_INSURER = 25,
  POLICY_COPY = 26,
  PAYMENT_BREAKDOWN = 27,
  LETTER_REMOVING_LIEN = 28,
  SALE_AGREEMENT = 29,
  EMAIL_FROM_INSURANCE_COMPANY = 30,
  THIRD_PARTY_PAYER_INTEREST_FORM = 31,
  CREDIT_REFUND_APPROVAL_FOR_CUSTOMER = 32,
  CANCELLATION_NOTICE_FROM_INSURER = 33,
  BALANCE_REPORT = 34,
  LETTER_FROM_BANK = 35,
  CUSTOMER_PAYMENT = 36,
  CHECK_TO_CUSTOMER = 37,
  CORRESPONDENCE_WITH_INSURER = 38,
  DEBT_LETTER_TO_CUSTOMER = 39,
  CLAIM_FORM = 40,
  NATIONAL_INSURANCE = 41,
  LETTER_FROM_INSURER = 42,
  PERSONAL_DETAILS_QUESTIONNAIRE = 43,
  SENDING_CANCELLATION_TO_INSURER = 44,
  INSURER_CONFIRMATION_OF_CANCELLATION_REQUEST = 45,
  TRANSACTION_DISPUTE = 46,
  SPECIAL_DISCOUNT_APPROVAL_FORM = 47,
  AGENT_APPOINTMENT = 48,
  REGRET_LETTER_NOT_FOR_INSURER = 49,
  RECORDING_FILE = 50,
  INSURED_REQUEST_FORM = 51,
  INSURER_CONFIRMATION_OF_RECEIVING_EMAIL = 52,
  CHECK_IMAGE = 53,
  RECEIPT = 54,
  TAX_CERTIFICATE = 55,
  RENEWAL_CONFIRMATION = 56,
  EARTHQUAKE_FORM = 57,
  CORRESPONDENCE_WITH_CUSTOMER = 58,
  SURVEYOR_REPORT = 59,
  FUNDS_TRANSFER = 60,
  INSURED_DECLARATION = 61,
  PAYMENT_SLIP = 62,
  JEWELRY_SELECTION = 63,
  REMOVAL_OF_INSURED = 64,
  JEWELRY_INVOICE = 65,
  MEDICAL_MATERIAL = 66,
  POA_FOR_AGENT_APPOINTMENT = 67,
  NON_RENEWAL = 68,
  JEWELRY_WAIVER_FORM = 69,
  INHERITANCE_ORDER = 70,
  CUSTOMER_COMPLAINT = 71,
  APPRAISER_REPORT = 72,
  COVERED_INSURANCE_AMOUNTS = 73,
  PRELIMINARY_APPROVAL = 74,
  PAYSLIPS = 75,
  FINANCIAL_PROFILE = 76,
  INTERNAL_CORRESPONDENCE = 77,
  CORRESPONDENCE_WITH_BANK = 78,
  ANNUAL_COLLECTION_APPROVAL = 79,
  TENANT_UPDATE = 80,
  POLICY_EMAIL_TO_BANK = 81,
  BANK_CONFIRMATION_OF_RECEIVING_POLICY_EMAIL = 82,
  BAR_OZ_LETTER = 83,
  INSURANCE_MOUNTAIN_SCREENSHOT = 84,
  MISSING_INFO_COMPLETION = 85,
  INSURANCE_MOUNTAIN_DATA_FILE = 86,
  REJECTION_FROM_INSURER = 87,
  MEETING_SUMMARY = 88,
  EMPLOYER_LETTER = 89,
  MEDICAL_TESTS = 90,
  DUPLICATE_INSURANCE = 91,
  CANCELLATION_CONFIRMATION = 92,
  SURVEY_PERFORMED_BY_CUSTOMER = 93,
  DEATH_CERTIFICATE = 94,
  INSURER_CONFIRMATION_OF_RECEIVING_PROPOSAL = 95,
  REDEMPTION_FORM = 96,
  ISSUANCE_WITHOUT_POLICY_CANCELLATION = 97,
  POLICY_CANCELLATION_CONFIRMATION_NOT_FOR_INSURER = 98,
  POLICY_ORDER = 99,
  LIENHOLDER_UPDATE = 100,
  REDUCTION_APPROVAL = 101,
  PROPOSAL_CONTROL_FORM = 102,
  PAYMENT_METHOD_UPDATE = 103,
  WAIVER_OF_COMMERCIAL_AREA_COVERAGE = 104,
  TAX_REFUND_SIGNED_SERVICE_AGREEMENT = 105,
  TAX_REFUND_SCANNED_FILE = 106,
  TAX_REFUND_SUBMITTED_REPORTS = 107,
  POA_FOR_SIGNATURE_TAX_AUTHORITY = 108,
  POA_FOR_SIGNATURE_INTERNATIONAL = 109,
  SIGNED_POA_TAX_AUTHORITY = 110,
  SIGNED_POA_INTERNATIONAL = 111,
  TAX_REFUND_MALE_ID = 112,
  TAX_REFUND_FEMALE_ID = 113,
  TAX_REFUND_CHECK_BANK_ACCOUNT_APPROVAL = 114,
  ARCHIVED_PROPOSAL = 115,
  TAX_REFUND_GENERAL = 116,
  STANDING_ORDER = 117,
  PLUMBING_CLAIM = 118,
  TAX_REFUND_INVOICE_TO_CUSTOMER = 119,
  CLAIM_EMAIL = 120,
  PROOF_OF_SENDING_RECEIVING_POLICY = 121,
  POLICY_CONTROL_FORM = 122,
  THERAPIST_CERTIFICATE = 123,
  CLAIM_PAYMENT_CONFIRMATION = 124,
  MISSING_DOCUMENTS_FOR_CLAIM = 125,
  INSURANCE_RENEWAL_FORM = 126,
  POLICY_CHANGE_FORM = 127,
  BANK_TRANSFER = 128,
  INSURED_STRUCTURE_RENEWAL = 129,
  LIENHOLDER_STRUCTURE_RENEWAL = 130,
  LAWYER_LETTER = 131,
  LEAD_DETAILS = 132,
  NO_CLAIMS_CERTIFICATE = 133,
  PHOTOS = 134,
  COUNTER_OFFER = 135,
  RENEWAL_PROPOSAL_FORM = 136,
  CHECK_FOR_COLLECTION = 137,
  PAYMENT_REQUEST_CHECKS = 138,
  GENERAL_DOCUMENT = 900,
}

export enum DealRoomDisabledSection {
  LAMP_POLICY_AND_TERMS_AND_CONDITIONS = 'lamp-policy-and-terms-and-conditions',
  LAMP_SWIMMING_POOL_OF_THE_CONDOMINIUM = 'lamp-swimming-pool-of-the-condominium',
  LAMP_SHARED_GYM = 'lamp-shared-gym',
  LAMP_PLAYGROUND_OF_THE_CONDOMINIUM = 'lamp-playground-of-the-condominium',
  LAMP_PARKING_MULTIPLIER_VEHICLE_ELEVATOR_ROBOTIC_FACILITY = 'lamp-parking-multiplier-vehicle-elevator-robotic-facility',
  LAMP_COMMERCIAL_SPACES = 'lamp-commercial-spaces',
  LAMP_TENANT_ROOM_EVENT_ROOM_JAMBOREE = 'lamp-tenant-room-event-room-jamboree',
  LAMP_SAUNA_ROOM = 'lamp-sauna-room',
  LAMP_JACUZZI = 'lamp-jacuzzi',
  LAMP_PRIVATE_OPEN_SPACE = 'lamp-private-open-space',
  LAMP_MEMBERS_OF_A_CONDOMINIUM_REPRESENTATIVE_BODY = 'lamp-members-of-a-condominium-representative-body',

  RULE_SAMPLE_POLICY = 'rule-sample-policy',
  RULE_SWIMMING_POOL_OF_THE_CONDOMINIUM = 'rule-swimming-pool-of-the-condominium',
  RULE_PARKING_MULTIPLIER = 'rule-parking-multiplier',
  RULE_COMMERCIAL_SPACES = 'rule-commercial-spaces',
  RULE_PLAYGROUND_OF_THE_CONDOMINIUM = 'rule-playground-of-the-condominium',
  RULE_SHARED_GYM = 'rule-shared-gym',
  RULE_TENANT_ROOM_EVENT_ROOM = 'rule-tenant-room-event-room',

  PHOENIX_SAMPLE_POLICY = 'phoenix-sample-policy',
  PHOENIX_CONDOMINIUM_SWIMMING_POOL = 'phoenix-condominium-swimming-pool',
  PHOENIX_SHARED_GYM = 'phoenix-shared-gym',
  PHOENIX_CONDOMINIUM_PLAYGROUND_EQUIPMENT = 'phoenix-condominium-playground-equipment',
  PHOENIX_PARKING_MULTIPLIER_VEHICLE_ELEVATOR_ROBOTIC_FACILITY = 'phoenix-parking-multiplier-vehicle-elevator-robotic-facility',
  PHOENIX_COMMERCIAL_SPACES = 'phoenix-commercial-spaces',
  PHOENIX_TENANT_ROOM_EVENT_ROOM_GYM = 'phoenix-tenant-room-event-room-gym',
  PHOENIX_SAUNA_ROOM = 'phoenix-sauna-room',
  PHOENIX_JACUZZI = 'phoenix-jacuzzi',
  PHOENIX_MEMBERS_OF_THE_CONDOMINIUM_REPRESENTATIVE_BODY = 'phoenix-members-of-the-condominium-representative-body',

  TRAINING_SAMPLE_POLICY = 'training-sample-policy',

  AYALON_SAMPLE_POLICY = 'ayalon-sample-policy',
  AYALON_SAMPLE_LIST_PAGE = 'ayalon-sample-list-page',
}
